import { Badge } from "@atoms/Badge";
import { DecoratorSliderBall } from "@atoms/DecoratorSliderBall";

export const BadgeDecorator = (text: string) => {
  const BadgeDecoratorElement = document.createElement("div");
  BadgeDecoratorElement.className = "mx-auto w-max flex items-center gap-4";

  BadgeDecoratorElement.appendChild(DecoratorSliderBall("right"));
  BadgeDecoratorElement.appendChild(Badge(text));
  BadgeDecoratorElement.appendChild(DecoratorSliderBall("left"));

  return BadgeDecoratorElement;
};
